export const TEST_ID = {
  HEADER: {
    LOGO: "HEADER_LOGO",
    SELECT_LANGUAGE: "HEADER_SELECT_LANGUAGE",
    SELECT_LANGUAGE_OPTION: "HEADER_SELECT_LANGUAGE_OPTION",
    SEARCH_BAR: "HEADER_SEARCH_BAR",
  },
  ASIGE: {
    CATEGORIES: "ASIDE_CATEGORIES",
    CATEGORY: "ASIDE_CATEGORY",
  },
  FILTER: {
    SORTING_ITEMS: "FILTER_SORTING_ITEMS",
    SORTING_ASC: "FILTER_SORTING_ASC",
    SORTING_DESC: "FILTER_SORTING_DESC",
    DISPLAY_ICON: "FILTER_DISPLAY_ICON",
  },
  CONDIMENT: {
    WRAPPER: "CONDIMENT_CARD_WRAPPER",
    CARD: "CONDIMENT_CARD",
    MORE: "CONDIMENT_MORE",
    CHECKBOX: "CONDIMENT_CHECKBOX",
  },
  MIXTURE_TAB: {
    SELECTED_ITEMS: "MIXTURE_TAB_SELECTED_ITEMS",
    DELETE_BUTTON: "MIXTURE_TAB_DELETE_BUTTON",
    CONTINUE_BUTTON: "MIXTURE_TAB_CONTINUE_BUTTON",
  },
  MIX_CONFIGURATION: {
    ITEMS: "MIX_CONFIGURATION_ITEMS",
    INPUT_PARTS: "MIX_CONFIGURATION_INPUT_PARTS",
    INPUT_GRAMS: "MIX_CONFIGURATION_INPUT_GRAMS",
    INPUT_PERCENTAGE: "MIX_CONFIGURATION_INPUT_PERCENTAGE",
  },
  SUBCATEGORY: {
    SUBCATEGORY_ITEM: "SUBCATEGORY_ITEM",
  },
  CREATE_MIX: {
    NAME: "CREATE_MIX_NAME",

    LIST_ITEM: "CREATE_MIX_LIST_ITEM",
    LIST_ITEM_INCREMENT: "CREATE_MIX_LIST_ITEM_INCREMENT",
    LIST_ITEM_DECREMENT: "CREATE_MIX_LIST_ITEM_DECREMENT",

    SLIDER_INCREMENT: "CREATE_MIX_SLIDER_INCREMENT",
    SLIDER_DECREMENT: "CREATE_MIX_SLIDER_DECREMENT",
    SLIDER_DRAGGABLE: "CREATE_MIX_SLIDER_DRAGGABLE",

    JAR_WEIGHT: "CREATE_MIX_JAR_WEIGHT",
    JAR_QUANTITY: "CREATE_MIX_JAR_QUANTITY",

    DELETE_BUTTON: "CREATE_MIX_BUTTON_DELETE",
    CONTINUE_BUTTON: "CREATE_MIX_CONTINUE_BUTTON",

    CONFIRMATION_CANCEL_BUTTON: "CREATE_MIX_CONFIRMATION_CANCEL_BUTTON",
    CONFIRMATION_CONFIRM_BUTTON: "CREATE_MIX_CONFIRMATION_CONFIRM_BUTTON",

    MIN_VOLUME_VALUE: "CREATE_MIX_MIN_VOLUME_VALUE",
    MAX_VOLUME_VALUE: "CREATE_MIX_MAX_VOLUME_VALUE",

    MIXTURE_TYPE: "CREATE_MIX_MIXTURE_TYPE",
  },
  MIXES: {
    WRAPPER: "MIXES_WRAPPER",
    CARD: "MIXES_CARD",
  },
};
